import { FormControl, FormGroup } from '@angular/forms';

import { MissionAcceptanceFileType } from '@enums/mission-acceptance-file-type.enum';
import { MissionAcceptanceFile } from '@models/mission-acceptance-file';
import { User } from '@models/user';

export type MissionAcceptanceFileFormType = {
  id: FormControl<number | undefined>;
  title: FormControl<string | null>;
  name: FormControl<string | null>;
  type: FormControl<MissionAcceptanceFileType | null>;
  content: FormControl<File | null>;
  contact: FormControl<User | null>;
  contractId: FormControl<number | null>;
  createdAt: FormControl<string | null>;
  createdBy: FormControl<User | null>;
};

export class MissionAcceptanceFileForm extends FormGroup<MissionAcceptanceFileFormType> {
  get id(): FormControl<number | undefined> {
    return this.controls.id;
  }

  get title(): FormControl<string | null> {
    return this.controls.title;
  }

  get name(): FormControl<string | null> {
    return this.controls.name;
  }

  get type(): FormControl<MissionAcceptanceFileType | null> {
    return this.controls.type;
  }

  get content(): FormControl<File | null> {
    return this.controls.content;
  }

  get contact(): FormControl<User | null> {
    return this.controls.contact;
  }

  get contractId(): FormControl<number | null> {
    return this.controls.contractId;
  }

  get uniqId(): string {
    return JSON.stringify(this.getRawValue());
  }

  get createdAt(): FormControl<string | null> {
    return this.controls.createdAt;
  }

  get createdBy(): FormControl<User | null> {
    return this.controls.createdBy;
  }

  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined),
      title: new FormControl<string | null>(null),
      name: new FormControl<string | null>(null),
      type: new FormControl<MissionAcceptanceFileType | null>(null),
      content: new FormControl<File | null>(null),
      contact: new FormControl<User | null>(null),
      contractId: new FormControl<number | null>(null),
      createdAt: new FormControl<string | null>(null),
      createdBy: new FormControl<User | null>(null)
    });
  }

  fromFile(file: MissionAcceptanceFile): void {
    this.patchValue({
      id: file.id,
      title: file.title,
      name: file.name,
      type: file.type,
      contact: file.contact,
      contractId: file.contractId,
      createdAt: file.createdAt,
      createdBy: file.createdBy
    });
  }

  toFile(): MissionAcceptanceFile {
    const file: MissionAcceptanceFile = new MissionAcceptanceFile();

    file.id = this.id.value;
    file.title = this.title.value;
    file.name = this.name.value;
    file.type = this.type.value;
    file.contact = this.contact.value;
    file.file = this.content.value;
    file.contractId = this.contractId.value;

    return file;
  }
}
